import { GetAdvocateDetailsMeta, GetAdvocateDetailsPayload } from 'types/store/GetAdvocateDetails';
import { createAsyncReducer } from 'utils/Redux';

import { getAdvocateDetailsActions } from '../actions';

export default createAsyncReducer<GetAdvocateDetailsMeta, GetAdvocateDetailsPayload>(getAdvocateDetailsActions);
